import React, { Fragment, useState } from 'react';
import { Dialog } from '@headlessui/react';

import { Button, buttonVariants } from './UI/Button';
import { useTranslation } from 'react-i18next';

const PopupShippingUsPdp = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  function togglePopup() {
    setOpen(open => !open);
  }

  return (
    <Fragment>
      <button onClick={togglePopup} className="underline">
        {t('P_PDP.OVERVIEW.DELIVERY_US.3')}*
      </button>

      <Dialog open={open} onClose={togglePopup} className="relative z-70">
        <Dialog.Backdrop className="fixed inset-0 bg-black/30 " />

        <div className="fixed inset-0 flex items-center justify-center px-6 ">
          <Dialog.Panel className="w-full max-w-4xl bg-black rounded overflow-hidden shadow-xl">
            <div className="order-first flex flex-col bg-white text-black p-6">
              <div className="flex-1 flex flex-col justify-center space-y-6 p-3 md:p-4">
                <div className="space-y-6">
                  <div className="text-black">
                    <table className="max-w-5xl mx-auto w-full divide-y divide-gray-300">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-8"
                          >
                            {t('P_PDP.US_SHIPPING.TABLE_R_1_C_1')}
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-8"
                          >
                            {t('P_PDP.US_SHIPPING.TABLE_R_1_C_2')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8">
                            {t('P_PDP.US_SHIPPING.TABLE_R_2_C_1')}
                          </td>
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8">
                            {t('P_PDP.US_SHIPPING.TABLE_R_2_C_2')}
                          </td>
                        </tr>
                        <tr>
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8">
                            {t('P_PDP.US_SHIPPING.TABLE_R_3_C_1')}
                          </td>
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8">
                            {t('P_PDP.US_SHIPPING.TABLE_R_3_C_2')}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p className="text-sm mt-4">{t('P_PDP.US_SHIPPING.P')}</p>
                  </div>
                  <Button
                    onClick={togglePopup}
                    aria-label={t('US_SHIPPING.BTN_TEXT')}
                    className={buttonVariants({ variant: 'dark' })}
                  >
                    {t('US_SHIPPING.BTN_TEXT')}
                  </Button>
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </Fragment>
  );
};

export default PopupShippingUsPdp;
